import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconBrightnessLowComponent } from "./med-icon-brightness-low.component";

@NgModule({
  declarations: [
    MedIconBrightnessLowComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconBrightnessLowComponent,
  ],
})
export class MedIconBrightnessLowModule { }
